export default "__VITE_ASSET__Dna1Z7Wt__"